import { render } from "./QuickFixMenu.vue?vue&type=template&id=a4074696"
import script from "./QuickFixMenu.vue?vue&type=script&lang=js"
export * from "./QuickFixMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/QuickFixMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a4074696"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a4074696', __exports__)) {
    api.reload('a4074696', __exports__)
  }
  
  module.hot.accept("./QuickFixMenu.vue?vue&type=template&id=a4074696", () => {
    api.rerender('a4074696', render)
  })

}


export default __exports__